import { render, staticRenderFns } from "./EditorDashboard.vue?vue&type=template&id=311f8170&"
import script from "./EditorDashboard.vue?vue&type=script&lang=js&"
export * from "./EditorDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports